// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + ".bundle." + "9602043a08d73cad4192" + ".css";
};